import React from 'react';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import Content from "../components/Content";

import logoPDS from "./../assets/e-SIP-logo-white.png";
import logoPDSSub from "./../assets/e-SIP-logo-sub.png";


const ClientLayout = ({modules, navheader=null}) => {
  return (
    <div className="d-flex" id="wrapper">
      <div id="view-wrapper">
        <Navbar expand="lg" variant="light">
          <Container fluid="xl">
            <Navbar.Brand href="">
              <img alt="logo" className="logo" src={logoPDS} />
              <div className="vertical-bar"/>
              <img alt="logo2" className="logo-sub" src={logoPDSSub}/>
            </Navbar.Brand>
            <Navbar.Collapse>
              <Nav className="ml-auto" style={{color: 'white'}}>
                <b>{ navheader }</b>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <Content modules={modules}/>
      </div>
    </div>
  )
}

export default ClientLayout;
